import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import ButtonTertiaryDark from '@nexus/lib-react/dist/core/Button/ButtonTertiaryDark';
import { Modal } from '@nexus/lib-react/dist/core/Modal/Modal';
import mq from '../../../../../commons/styles/mediaQueries';
import styled from '../../../../../theme/styled';

/*
 The CTA link buttons style on safari is not consistent with the design system,
 hence -webkit-appearance needs to be set to none.
*/
const AcceptButton = styled(ButtonPrimaryDark)`
  padding: 0 10px;
  flex-grow: 1;
  width: 100%;
  font-size: ${({ theme }) => theme.sizes.m};
  -webkit-appearance: none;

  ${mq.desktop} {
    padding: 10px 16px 8px 16px;
  }
`;

const RejectButton = styled(ButtonTertiaryDark)`
  -webkit-appearance: none;
  width: 115px;
  margin-right: 10px;
  font-size: ${({ theme }) => theme.sizes.m};
  ${mq.desktop} {
    margin-top: 5px;
  }
`;

const Iframe = styled.iframe<{ isLoading: boolean }>`
  margin: 0px;
  padding: 0px;
  border: none;
  min-height: 150px;
  width: 100%;
  visibility: ${({ isLoading }) => (isLoading ? 'hidden' : 'visible')};
`;

const SellerRejectionModal = styled(Modal)`
  &[role='dialog'] > div:last-child {
    padding: 0;
  }
`;

export default {
  AcceptButton,
  RejectButton,
  Iframe,
  SellerRejectionModal,
};
